import { defineComponent } from 'vue'
import type { FamilyHistoryCollection } from '#models/family_history'

export default defineComponent({
  props: {
    familyHistory: {
      type: Object as () => FamilyHistoryCollection,
      required: true
    }
  }
})
